<!-- <div>
<i nz-icon nzType="database" nzTheme="twotone" class="header-icon"></i>&nbsp;<b class="header-label">Houses</b>
</div> -->
<pg-header
  title="Houses"
  ticon="database"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="hseLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="house list"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <!-- <div class="cursor-pointer tblEdtBtn" (click)="onCellClick('edit',data)">
            Edit
          </div> -->
            <div class="tblEdtBtn" (click)="onEdit(data)">Edit House</div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate2"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate2" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="onEditCntct(data)">
              Edit Contact
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div class="tblDelBtn" (click)="onDelete(data)">Delete House</div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate2"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate2" let-data="cell"
          ><div>
            <div class="tblDelBtn" (click)="onDeleteCntct(data)">
              Delete Contact
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="350"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    @if (shwEditCntctDiv==false && shwDelCntctDiv==false) {
    <form nz-form [formGroup]="houseForm">
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="blksMrgn"
        >
          <div class="inptLbl">Gate Name</div>
          <nz-input-wrapper [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              placeholder="Enter house number"
              formControlName="gte_nm"
              (blur)="getGateid()"
            />
          </nz-input-wrapper>
          @if (shwalert == true) {
          <div nz-row style="margin-top: 10px" class="blksMrgn">
            <nz-alert
              [nzCloseable]="true"
              nzType="error"
              nzMessage="Please enter valid Gate"
            ></nz-alert>
          </div>
          }
          <div class="inptLbl">Door Number</div>
          <nz-input-wrapper [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              placeholder="Enter door number"
              formControlName="dr_nu"
            />
          </nz-input-wrapper>
          <div class="inptLbl">Floor Number</div>
          <nz-input-wrapper [nzSuffix]="inputClearTpl">
            <input
              type="number"
              nz-input
              placeholder="Enter floor number"
              formControlName="flr_nu"
            />
          </nz-input-wrapper>
          <div class="inptLbl">Total Population</div>
          <nz-input-wrapper [nzSuffix]="inputClearTpl">
            <input
              type="number"
              nz-input
              placeholder="Enter total population"
              formControlName="ple_ct"
            />
          </nz-input-wrapper>
        </div>
      </div>
      <!-- <div class="mb-20">
          <div class="inptLbl">ULB</div>
          <input placeholder="Select ULBs" nz-input [(ngModel)]="hseDt.ulb_nm" (ngModelChange)="onUlbChange($event)" formControlName="ulb_id"
            [nzAutocomplete]="auto" />
            <nz-autocomplete #auto>
              <nz-auto-option *ngFor="let d of filteredULBOptions" [nzValue]="d.ulb_nm" (click)="getULBID(d.ulb_id);">{{d.ulb_nm}}</nz-auto-option>
            </nz-autocomplete>
          </div> -->
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="blksMrgn"
        >
          <div class="inptLbl">ULB</div>
          <nz-select
            nzShowSearch
            style="width: 100%"
            nzPlaceHolder="Select ULB"
            formControlName="ulb_id"
            (ngModelChange)="getscvlym()"
          >
            @for (u of ulbs; track u) {
            <nz-option [nzValue]="u.ulb_id" [nzLabel]="u.ulb_nm"> </nz-option>
            }
          </nz-select>
        </div>
      </div>
      <!-- </div> -->
      <!-- <div class="inptLbl">Ward</div>
        <nz-select nzShowSearch style="width: 100%;" nzPlaceHolder="Select Ward" formControlName="wrd_id"  [(ngModel)]="hseDt.wrd_nm">
          <nz-option *ngFor="let w of wards" [nzValue]="w.wrd_id" [nzLabel]="w.wrd_nm">
          </nz-option>
        </nz-select> -->
      <div class="inptLbl">Sachivalayam Name</div>
      <nz-select
        nzShowSearch
        style="width: 100%"
        nzPlaceHolder="Select Sachivalayam"
        formControlName="svm_id"
        (ngModelChange)="getcluster()"
      >
        @for (s of schvlymlst; track s) {
        <nz-option [nzValue]="s.svm_id" [nzLabel]="s.svm_nm"> </nz-option>
        }
      </nz-select>
      <div class="inptLbl">Cluster Name</div>
      <nz-select
        nzShowSearch
        style="width: 100%"
        nzPlaceHolder="Select Cluster"
        formControlName="tu_id"
        (ngModelChange)="gethseCtgry()"
      >
        @for (c of clusterlst; track c) {
        <nz-option [nzValue]="c.tu_id" [nzLabel]="c.tu_nm"> </nz-option>
        }
      </nz-select>
      <div class="inptLbl">House Type</div>
      <nz-select
        nzShowSearch
        style="width: 100%"
        nzPlaceHolder="Select House Type"
        formControlName="hse_ctgry_id"
        (ngModelChange)="gethseStatus()"
      >
        @for (c of hseCtgry; track c) {
        <nz-option [nzValue]="c.hse_ctgry_id" [nzLabel]="c.hse_ctgry_nm">
        </nz-option>
        }
      </nz-select>
      <div class="inptLbl">House Status</div>
      <nz-select
        nzShowSearch
        style="width: 100%"
        nzPlaceHolder="Select House Status"
        formControlName="hse_sts_id"
      >
        @for (s of hseStatus; track s) {
        <nz-option [nzValue]="s.hse_sts_id" [nzLabel]="s.hse_sts_nm">
        </nz-option>
        }
      </nz-select>
    </form>
    }
    <!-- <div *ngIf="addDtls==true"> -->
    <!-- <div>Add contact person Details</div> -->
    @if (shwEditDiv==false && shwDelDiv==false) {
    <form nz-form [formGroup]="cntactForm">
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="blksMrgn"
        >
          <div class="inptLbl">Contact Person first Name</div>
          <nz-input-wrapper [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              placeholder="Enter First Name"
              formControlName="frst_nm"
            />
          </nz-input-wrapper>
          <div class="inptLbl">Contact Person Last Name</div>
          <nz-input-wrapper [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              placeholder="Enter Last Name"
              formControlName="lst_nm"
            />
          </nz-input-wrapper>
          <div class="inptLbl">Contact Number</div>
          <nz-input-wrapper
            [nzSuffix]="inputClearTpl"
            nzErrorTip="MaxLength is 10"
          >
            <input
              type="Number"
              nz-input
              placeholder="Enter Mobile number"
              formControlName="mbl_nu"
            />
          </nz-input-wrapper>
          <div class="inptLbl">Is Owner of House</div>
          <nz-select
            nzShowSearch
            style="width: 100%"
            nzPlaceHolder="Select House Type"
            formControlName="ownr"
          >
            @for (o of Ownerdta; track o) {
            <nz-option [nzValue]="o.id" [nzLabel]="o.type"> </nz-option>
            }
          </nz-select>
        </div>
      </div>
    </form>
    }
    <!-- </div> -->
    <!-- <div *ngIf="addDtls==true"> -->
    <ng-template #inputClearTpl
      >@if (hseDt.gte_hse_nu) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="hseDt = {}"
      ></i>
      }</ng-template
    >
    @if (shwEditDiv==false && shwDelDiv==false && shwEditCntctDiv==false &&
    shwDelCntctDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveNew()">
      Submit
    </button>
    } @if (shwEditDiv==true && shwDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveEdit()">
      Update
    </button>
    } @if (shwEditDiv==false && shwDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this house?"
      nzPopconfirmPlacement="bottom"
      [nzIcon]="iconTpl"
      nzOkType="danger"
      nzOkText="YES"
      nzCancelText="NO"
      (nzOnConfirm)="saveDelete()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    }
    <button nz-button nzType="default" class="cnclBtn" (click)="cancelbtn()">
      Cancel
    </button>
    @if (shwEditCntctDiv==true && shwDelCntctDiv==false) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveEditCntct()"
    >
      Update Contact
    </button>
    } @if (shwEditCntctDiv==false && shwDelCntctDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this house?"
      nzPopconfirmPlacement="bottom"
      [nzIcon]="iconTpl"
      nzOkType="danger"
      nzOkText="YES"
      nzCancelText="NO"
      (nzOnConfirm)="saveDeleteCntct()"
      (nzOnCancel)="cancel()"
    >
      Delete Contact
    </button>
    }
    <ng-template #iconTpl>
      <i nz-icon nzType="question-circle-o" style="color: red"></i>
    </ng-template>
    <!-- </div> -->
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
